export function modKeyDown(ev: MouseEvent) {
	const isOSX = navigator.platform.toLowerCase().indexOf('mac') !== -1;
	return isOSX && ev.metaKey || !isOSX && ev.ctrlKey;
}
